(function () {

  function getProductTags(productHandle) {
    return fetch('/products/' + productHandle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { return p.tags || []; });
  }

  function getCartItemTags() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.items.length === 0) return [];
        var promises = cart.items.map(function (item) {
          return getProductTags(item.handle);
        });
        return Promise.all(promises).then(function (allTags) {
          var flat = [];
          allTags.forEach(function (tags) { flat = flat.concat(tags); });
          return flat;
        });
      });
  }

  function hasTag(tags, tag) {
    return tags.indexOf(tag) !== -1;
  }

  function showError(container, message) {
    var existing = container.querySelector('.virginia-cart-error');
    if (existing) existing.remove();
    var div = document.createElement('div');
    div.className = 'virginia-cart-error';
    div.style.cssText = [
      'background:#fff3cd',
      'border:1px solid #f0c040',
      'color:#7a5c00',
      'font-size:13px',
      'line-height:1.6',
      'padding:12px 16px',
      'margin-bottom:16px',
      'font-family:Georgia,serif'
    ].join(';');
    div.textContent = message;
    var submitBtn = container.querySelector('[type="submit"][name="add"]');
    if (submitBtn) {
      submitBtn.parentNode.insertBefore(div, submitBtn);
    } else {
      container.appendChild(div);
    }
    setTimeout(function () { div.remove(); }, 6000);
  }

  function getHandle() {
    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      var parts = canonical.href.split('/products/');
      if (parts[1]) return parts[1].split('?')[0].split('/')[0];
    }
    return null;
  }

  function resetButton(instance) {
    var btn = instance.querySelector('[type="submit"]');
    if (btn) {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
    }
    var spinner = instance.querySelector('.loading__spinner');
    if (spinner) spinner.classList.add('hidden');
  }

  function patchProductForm(instance) {
    if (instance._guardPatched) return;
    instance._guardPatched = true;

    var form = instance.form;
    if (!form) return;

    var originalHandler = instance.onSubmitHandler.bind(instance);

    var guardHandler = function (evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();

      var handle = getHandle();
      if (!handle) {
        originalHandler(evt);
        return;
      }

      Promise.all([
        getProductTags(handle),
        getCartItemTags()
      ]).then(function (results) {
        var newTags      = results[0];
        var cartTags     = results[1];

        var newIsPreordine   = hasTag(newTags, 'preordine');
        var newIsPronta      = hasTag(newTags, 'pronta-consegna');
        var cartHasPreordine = hasTag(cartTags, 'preordine');
        var cartHasPronta    = hasTag(cartTags, 'pronta-consegna');

        var conflict = (newIsPreordine && cartHasPronta) ||
                       (newIsPronta    && cartHasPreordine);

        if (conflict) {
          var tipoNuovo     = newIsPreordine ? 'preordine' : 'pronta consegna';
          var tipoEsistente = cartHasPreordine ? 'preordine' : 'pronta consegna';
          showError(instance,
            'Non è possibile combinare prodotti di tipo "' + tipoNuovo +
            '" con prodotti di tipo "' + tipoEsistente +
            '" già presenti nel carrello. Svuota il carrello prima di procedere.'
          );
          resetButton(instance);
        } else {
          form.removeEventListener('submit', guardHandler, true);
          originalHandler(evt);
          form.addEventListener('submit', guardHandler, true);
        }
      }).catch(function () {
        form.removeEventListener('submit', guardHandler, true);
        originalHandler(evt);
        form.addEventListener('submit', guardHandler, true);
      });
    };

    form.removeEventListener('submit', originalHandler, false);
    form.removeEventListener('submit', originalHandler, true);
    form.addEventListener('submit', guardHandler, true);
  }

  function waitForProductForm() {
    if (customElements.get('product-form')) {
      var OriginalClass = customElements.get('product-form');
      var originalConnected = OriginalClass.prototype.connectedCallback;

      OriginalClass.prototype.connectedCallback = function () {
        if (originalConnected) originalConnected.call(this);
        var self = this;
        setTimeout(function () { patchProductForm(self); }, 0);
      };

      document.querySelectorAll('product-form').forEach(function (el) {
        setTimeout(function () { patchProductForm(el); }, 0);
      });

    } else {
      setTimeout(waitForProductForm, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForProductForm);
  } else {
    waitForProductForm();
  }

})();